// Standardized dropdown options for Region and Industry
// These values ensure data consistency across the application

export const REGION_OPTIONS = [
  'Gurgaon',
  'Delhi NCR',
  'Mumbai',
  'Bangalore',
  'Chennai',
  'Hyderabad',
  'Kolkata',
  'Pune',
  'Ahmedabad',
  'Other'
];

export const INDUSTRY_OPTIONS = [
  'Beauty & Wellness',
  'Construction & Real Estate',
  'Education & Training',
  'Entertainment & Media',
  'Events & Weddings',
  'Finance & Insurance',
  'Fitness & Yoga',
  'Food & Hospitality',
  'Gems & Jewellery',
  'Healthcare & Wellness',
  'HR & Recruitment',
  'IT & Technology',
  'Legal & Consulting',
  'Manufacturing',
  'Marketing & Advertising',
  'Printing & Packaging',
  'Retail & E-commerce',
  'Travel & Tourism',
  'Other'
];
